import { useEffect, useState } from "react";
import { adminToastEvent } from "@/lib/admin-toast";

/** Lightweight host instead of sonner: no extra dependency, used only after navigating away from a form. */
export function ToastHost() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    function onToast(event: Event) {
      if (!(event instanceof CustomEvent) || typeof event.detail !== "string" || !event.detail.trim()) return;
      setMessage(event.detail);
    }
    window.addEventListener(adminToastEvent, onToast);
    return () => window.removeEventListener(adminToastEvent, onToast);
  }, []);

  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(() => setMessage(null), 4000);
    return () => window.clearTimeout(timer);
  }, [message]);

  if (!message) return null;
  return (
    <div
      className="pointer-events-none fixed right-4 top-16 z-50 max-w-sm rounded-sm border border-line bg-panel px-4 py-3 text-sm text-ink shadow-panel"
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  );
}
